export const characterFormMessages = {
  // Form Headings
  heading: 'Character Details',
  subheading: 'Create a new character for your story',

  // Character Selection
  characterSelectionLabel: 'Character Selection',
  characterSelectionPlaceholder: 'Choose how to add this character',
  useExistingCharacter: 'Use Existing Character',
  createNewCharacter: 'Create New Character',
  selectExistingCharacter: 'Select Existing Character',
  selectExistingCharacterPlaceholder: 'Choose an existing character',

  // Form Labels
  characterNameLabel: 'Character Name',
  ageLabel: 'Age',
  genderLabel: 'Gender',
  photoLabel: 'Character Photo',

  // Form Placeholders
  characterNamePlaceholder: 'Enter character name',
  agePlaceholder: 'Enter age',
  genderPlaceholder: 'Select gender',

  // Photo Upload
  photoPlaceholder: 'Click to upload a photo',
  photoSupportedFormats: 'Supports: JPG, PNG, GIF (max 5MB)',
  clickToChangeImage: 'Click to change image',
  fileSizeMB: 'MB',
  characterPreviewAlt: 'Character preview',

  // Buttons
  createCharacters: 'Create Characters',
  createCharacter: 'Create Character',
} as const;
